export const traitKeys = {
  all: ["traits"] as const,
  memberTraits: (prospect_guid: string | undefined) =>
    [...traitKeys.all, "memberTraits", prospect_guid] as const,
}
